import { render } from "./UserView.vue?vue&type=template&id=9460a7d2&scoped=true&ts=true"
import script from "./UserView.vue?vue&type=script&lang=ts"
export * from "./UserView.vue?vue&type=script&lang=ts"

import "./UserView.vue?vue&type=style&index=0&id=9460a7d2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9460a7d2"]])

export default __exports__